
import "./App.css";
import NavBar from "./components/Navbar";

function App() {
  return (
    <div>
      <header>
        <div className="logo-container">
          <img className="logo" src={`${process.env.PUBLIC_URL}/final-logo.png`}
            alt="Valeria's logo displaying her name in cursive writing: Valeria Castro-Yoskovich.">
          </img>
        </div>
        <NavBar></NavBar>
      </header>
    </div>
  );
}

export default App;
